module.exports = __webpack_public_path__ + "3ac75dacaca27b317e5d50c7d0dc9c7c.svg";